import { RootState } from '..';
import { CustomerTypes } from '../customers/customers.actions';
import { GradeTypes } from '../grades/grades.actions';
import { InstrumentGroupTypes } from '../instrumentgroups/instrumentgroups.actions';
import { InstrumentTypes } from '../instruments/instruments.actions';
import { MethodTypes } from '../methods/methods.actions';
import { MixtureTypes } from '../mixtures/mixtures.actions';
import { MixtureTypeTypes } from '../mixturetypes/mixturetypes.actions';
import { PackagingTypes } from '../packagings/packagings.actions';
import { PalletTypes } from '../pallets/pallets.actions';
import { LabelTemplateTypes } from '../labelTemplates/labelTemplates.actions';
import { ParameterGroupTypes } from '../parametergroups/parametergroups.actions';
import { ParameterTypes } from '../parameters/parameters.actions';
import { ParameterSetTypes } from '../parametersets/parametersets.actions';
import { PlantTypes } from '../plants/plants.actions';
import { ProductTypes } from '../products/products.actions';
import { ProductTypeTypes } from '../producttypes/producttypes.actions';
import { RecipientTypes } from '../recipients/recipients.actions';
import { RunSystemTypes } from '../runsystems/runsystems.actions';
import { SegmentTypes } from '../segments/segments.actions';
import { SpecificationTypes } from '../specifications/specifications.actions';

export const isLoadingProducts = (state: RootState) =>
  state.requests.inProgress.includes(ProductTypes.FetchAll) ||
  state.requests.inProgress.includes(ProductTypes.FetchFiltered) ||
  state.requests.inProgress.includes(ProductTypes.FetchFilteredParameters);

export const isLoadingMixtures = (state: RootState) =>
  state.requests.inProgress.includes(MixtureTypes.FetchAll) ||
  state.requests.inProgress.includes(MixtureTypes.FetchFiltered);

export const isLoadingSpecifications = (state: RootState) =>
  state.requests.inProgress.includes(SpecificationTypes.FetchAll) ||
  state.requests.inProgress.includes(SpecificationTypes.FetchFiltered);

export const isLoadingGrades = (state: RootState) =>
  state.requests.inProgress.includes(GradeTypes.FetchAll) &&
  state.grades.grades?.length > 0;

export const isLoadingRunSystems = (state: RootState) =>
  state.requests.inProgress.includes(RunSystemTypes.FetchAll) &&
  state.runSystems.runSystems?.length > 0;

export const isLoadingParameters = (state: RootState) =>
  state.requests.inProgress.includes(ParameterTypes.FetchAll) &&
  state.parameters.parameters?.length > 0;

export const isLoadingParameterGroups = (state: RootState) =>
  state.requests.inProgress.includes(ParameterGroupTypes.FetchAll) &&
  state.parameterGroups.parameterGroups?.length > 0;

export const isLoadingMethods = (state: RootState) =>
  state.requests.inProgress.includes(MethodTypes.FetchAll) &&
  state.methods.methods?.length > 0;

export const isLoadingInstruments = (state: RootState) =>
  state.requests.inProgress.includes(InstrumentTypes.FetchAll) &&
  state.instruments.instruments?.length > 0;

export const isLoadingInstrumentGroups = (state: RootState) =>
  state.requests.inProgress.includes(InstrumentGroupTypes.FetchAll) &&
  state.instrumentGroups.instrumentGroups?.length > 0;

export const isLoadingPlants = (state: RootState) =>
  state.requests.inProgress.includes(PlantTypes.FetchAll) &&
  state.plants.plants?.length > 0;

export const isLoadingProductTypes = (state: RootState) =>
  state.requests.inProgress.includes(ProductTypeTypes.FetchAll) &&
  state.productTypes.productTypes?.length > 0;

export const isLoadingSegments = (state: RootState) =>
  state.requests.inProgress.includes(SegmentTypes.FetchAll) &&
  state.segments.segments?.length > 0;

export const isLoadingPallets = (state: RootState) =>
  state.requests.inProgress.includes(PalletTypes.FetchAll) &&
  state.pallets.pallets?.length > 0;
export const isLoadingLabelTemplates = (state: RootState) =>
  state.requests.inProgress.includes(LabelTemplateTypes.FetchAll) &&
  state.labelTemplates.labelTemplates?.length > 0;

export const isLoadingPackagings = (state: RootState) =>
  state.requests.inProgress.includes(PackagingTypes.FetchAll) &&
  state.packagings.packagings?.length > 0;

export const isLoadingCustomers = (state: RootState) =>
  state.requests.inProgress.includes(CustomerTypes.FetchAll) &&
  state.customers.customers?.length > 0;

export const isLoadingRecipients = (state: RootState) =>
  state.requests.inProgress.includes(RecipientTypes.FetchAll) &&
  state.recipients.recipients?.length > 0;

export const isLoadingMixtureTypes = (state: RootState) =>
  state.requests.inProgress.includes(MixtureTypeTypes.FetchAll) &&
  state.mixtureTypes.mixtureTypes?.length > 0;

export const isLoadingParameterSets = (state: RootState) =>
  state.requests.inProgress.includes(ParameterSetTypes.FetchAll) &&
  state.parameterSets.parameterSets?.length > 0;
